import Snackbar from '@/components/Snackbar';
import type { Color } from '@/utils/material';
import type { ReactNode, SyntheticEvent } from 'react';
import type { ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';

const showToast = (severity: Color, msg: string | ReactNode, options?: ToastOptions) => {
  toast(
    ({ closeToast }) => (
      <Snackbar
        onClose={closeToast as (event: SyntheticEvent<Element, Event>) => void}
        severity={severity}
        msg={msg}
      />
    ),
    options,
  );
};

const message = {
  error: (msg: string | ReactNode, options?: ToastOptions) => showToast('error', msg, options),
  success: (msg: string | ReactNode, options?: ToastOptions) => showToast('success', msg, options),
  info: (msg: string | ReactNode, options?: ToastOptions) => showToast('info', msg, options),
  warning: (msg: string | ReactNode, options?: ToastOptions) => showToast('warning', msg, options),
};

export default message;
